import { gql } from '@apollo/client';

export interface Input {
  id: number;
  creditCardProcessingFeeBase?: number;
  creditCardProcessingFeeRate?: number;
  achProcessingFeeBase?: number;
  achProcessingFeeRate?: number;
}

export interface Data {
  updateOrganizationSettings: any;
}

export const MUTATION = gql`
  mutation UpdateOrganizationSettings(
    $id: ID!
    $creditCardProcessingFeeBase: Int
    $creditCardProcessingFeeRate: Float
    $achProcessingFeeBase: Int
    $achProcessingFeeRate: Float
  ) {
    updateOrganizationSettings(
      organizationId: $id
      input: {
        creditCardProcessingFeeBase: $creditCardProcessingFeeBase
        creditCardProcessingFeeRate: $creditCardProcessingFeeRate
        achProcessingFeeBase: $achProcessingFeeBase
        achProcessingFeeRate: $achProcessingFeeRate
      }
    ) {
      creditCardProcessingFeeBase
      creditCardProcessingFeeRate
      achProcessingFeeBase
      achProcessingFeeRate
    }
  }
`;
